import { Button } from "@rio-cloud/rio-uikit";
import Dialog from "@rio-cloud/rio-uikit/Dialog";
import { useEffect, useState } from "react";

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (payload: { document: string; name: string }) => void;
  title: string;
  editDocument?: string;
  editName?: string;
}

const DialogCreateClient = ({ show, onClose, onSave, title, editDocument, editName }: Props) => {
  const [documentError, setDocumentError] = useState("");
  const [document, setDocument] = useState(editDocument || "");
  const [name, setName] = useState(editName || "");

  const handleSubmit = () => {
    const trimmedDocument = document.trim();
    if (!trimmedDocument) {
      setDocumentError("Campo obrigatório");
      return;
    }

    setDocumentError("");
    onSave({
      document: trimmedDocument,
      name: name.trim(),
    });
    handleClose();
  };

  const handleClose = () => {
    onClose();
    setDocument("");
    setName("");
    setDocumentError("");
  };

  useEffect(() => {
    setDocument(editDocument ?? "");
    setName(editName ?? "");
    setDocumentError("");
  }, [editDocument, editName, show]);

  return (
    <Dialog
      show={show}
      title={<span className="text-medium text-size-16">{title}</span>}
      body={
        <div className="padding-10">
          <div className={`form-group ${documentError ? "has-feedback has-error" : ""}`}>
            <label htmlFor="inputClientDocument">
              <span>CNPJ / CPF *</span>
            </label>
            <div className="input-group width-100pct">
              <input
                id="inputClientDocument"
                type="text"
                className="form-control"
                value={document}
                onChange={(e) => {
                  setDocument(e.target.value);
                  if (documentError) setDocumentError("");
                }}
                name="document"
                placeholder="Digite o CNPJ ou CPF do cliente"
              />
            </div>
            {documentError ? <span className="form-control-feedback rioglyph rioglyph-error-sign" /> : null}
            {documentError && (
              <span className="help-block">
                <span>{documentError}</span>
              </span>
            )}
          </div>

          <div className="form-group margin-top-15">
            <label htmlFor="inputClientName">
              <span>Nome (opcional)</span>
            </label>
            <div className="input-group width-100pct">
              <input
                id="inputClientName"
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                name="name"
                placeholder="Digite o nome do cliente"
              />
            </div>
          </div>
        </div>
      }
      onClose={handleClose}
      footer={
        <div className="display-flex align-items-center justify-content-end gap-10">
          <Button onClick={handleClose} className="width-150 rounded-small">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} bsStyle={Button.PRIMARY} className="width-150 rounded-small">
            Salvar
          </Button>
        </div>
      }
      showCloseButton
      useOverflow
    />
  );
};

export default DialogCreateClient;
